let payKeys = "";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === ""
) {
  payKeys = "http://localhost:4000";
} else if (window.location.hostname === "lp.goola.run") {
  payKeys = "https://pay.goola.run";
} else if (window.location.hostname === "d2sygywnmd0lrr.cloudfront.net") {
  payKeys = "https://d18psq8exj9g9a.cloudfront.net";
}

export default payKeys;
